/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.payment', {
            parent: 'board',
            url: '/board/payment?page&sort&search',
            data: {
                authorities: ['ROLE_FINANCE'],
                pageTitle: 'askApp.payment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/board/payment/payments.html',
                    controller: 'BoardPaymentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'date,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('payment');
                    $translatePartialLoader.addPart('enumPaymentType');
                    $translatePartialLoader.addPart('enumPaymentCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.payment.edit', {
            parent: 'board.payment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/payment/payment-dialog.html',
                    controller: 'BoardPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['BoardPayment', function(BoardPayment) {
                            return BoardPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.payment', null, { reload: 'board.payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.payment.delete', {
            parent: 'board.payment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/payment/payment-delete-dialog.html',
                    controller: 'BoardPaymentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BoardPayment', function(BoardPayment) {
                            return BoardPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('board.payment', null, { reload: 'board.payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('board.payment.dept-edit', {
            parent: 'board.payment',
            url: '/dept/{deptId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/board/dept/dept-dialog.html',
                    controller: 'BoardDeptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('dept');
                            $translatePartialLoader.addPart('booking');
                            $translatePartialLoader.addPart('enumPaymentCategory');
                            return $translate.refresh();
                        }],
                        entity: ['Dept', function (Dept) {
                            return Dept.get({id: $stateParams.deptId}).$promise;
                        }],
                        entityProfile: null,
                        entityProject: null,
                        entityDinghyEvent: null
                    }
                }).result.then(function () {
                    $state.go('board.payment', null, {reload: 'board.payment'});
                }, function () {
                    $state.go('^');
                });
            }]
        });
    }

})();
